export default {
  'moduleTitle.address': 'Адрес',
  'moduleTitle.address_details': 'Детайли за адреса',
  'moduleTitle.activity_details': 'Детайли за дейността',
  'moduleTitle.add_log': 'Добави запис',
  'moduleTitle.award_level': 'Ниво в Наградата',
  'moduleTitle.adventurous_journey': 'Приключеснко пътуване',
  'moduleTitle.already_assessed': 'Вече е оценено!',
  'moduleTitle.approved': 'Одобрен!',
  'moduleTitle.assessor_details': 'Информация за ментора',
  'moduleTitle.authorising_contact_license_holder': 'Упълномощаващ контакт / Притежател на лиценза',
  'moduleTitle.category_journey_details': '{category} Детайли за Приключенско пътуване',
  'moduleTitle.complete_report': 'Завършен доклад',
  'moduleTitle.completed_progress': 'Завършен {finished} / {total}',
  'moduleTitle.congratulation': 'Поздравления!',
  'moduleTitle.confirming_email_address': 'Потвърждение на имейл адрес...',
  'moduleTitle.contact_details': 'Информация за контакт',
  'moduleTitle.edit_log': 'Редактирай записа',
  'moduleTitle.event_journey': '{event} Приключенско пътуване',
  'moduleTitle.forgotten_password': 'Забравена парола',
  'moduleTitle.great_you_are_almost_there': 'Чудесно, почти си готов/а. Последната стъпка е плащането на таксата за новото ниво в Наградата.',
  'moduleTitle.home_address': 'Домашен адрес',
  'moduleTitle.journey_overview': 'Преглед на Приключенско пътуване',
  'moduleTitle.log_detail': 'Детайли за записа',
  'moduleTitle.login': 'Вход',
  'moduleTitle.new_activity': 'Нова дейност',
  'moduleTitle.new_event_journey': 'Ново {event} Приключенско пътуване',
  'moduleTitle.new_residential_project': 'Нов проект в полза на общността',
  'moduleTitle.notRegistred': 'Нямаш регистрация?',
  'moduleTitle.nominated_award_leader_contact_details': 'Контактна информация на номинирания Лидер',
  'moduleTitle.nominated_award_leader': 'Номиниран Лидер',
  'moduleTitle.organisation_address': 'Адрес на организацията',
  'moduleTitle.organisation_details': 'Информация за организацията',
  'moduleTitle.online_record_book_account': 'ORB профил',
  'moduleTitle.page_not_found': '404 - Страницата не е намерена',
  'moduleTitle.personal_details': 'Лични данни',
  'moduleTitle.preparation_and_training': 'Подготовка и инструктажи',
  'moduleTitle.profile_guardian_consent': 'Съгласие от родител/настойник',
  'moduleTitle.profile_questions': 'Въпроси за профила',
  'moduleTitle.registration_for_level': 'Регистрация за ново ниво',
  'moduleTitle.residential_project': 'Проект в полза на общността',
  'moduleTitle.residential_project_details': 'Информация за Проект в полза на общността',
  'moduleTitle.reset_password': 'Промени паролата',
  'moduleTitle.welcome_to_the_orb': 'Добре дошъл в Онлайн Системата на Наградата',
  'moduleTitle.we_have_sent_you_an_email': 'Изпратихме ти имейл с линк за активиране на профила.',
  'moduleTitle.your_registration_is_complete': 'Регистрацията ти е завършена',
  'formTitle.activity_details': 'Детайли за дейността',
  'formTitle.assessor_details': 'Информация за оценителя',
  'formTitle.supervisors_details': 'Информация за супервайзора',
  'formTitle.preparation_and_training_activities': 'Дейности за подготовка и инструктажи',
  'formTitle.added_preparation_activities': 'Добавени дейности за подготовка и инструктажи',
  'label.add_picture': 'Добави снимка',
  'label.address_first_line': 'Адрес',
  'label.address_second_line': 'Адрес (по избор)',
  'label.are_you_already_running_award': 'Работите ли вече с Наградата?',
  'label.are_you_the_main_award_leader': 'Вие ли сте Координатора за вашата организация?',
  'label.award_participant': 'Участник в Наградата',
  'label.award_leader': 'Лидер в Наградата',
  'label.birthdate': 'Дата на раждане',
  'label.category': 'Категория',
  'label.change_locale': 'Промени местоположението',
  'label.choose_project': 'Избери проект',
  'label.city': 'Град',
  'label.choose_as_major_activity': 'Избери като основна дейност',
  'label.date': 'Дата',
  'label.date_of_birth': 'Дата на раждане',
  'label.description_of_progress': 'Описание на прогреса',
  'label.duration': 'Продължителност (мин.)',
  'label.email': 'Имейл',
  'label.email_address': 'Имейл адрес',
  'label.email_again': 'Имейл отново',
  'label.employment_status': 'Заетост',
  'label.end_date': 'Крайна дата',
  'label.enter_his_email': 'Въведи имейл адрес',
  'label.entered_transaction_id': 'ID на транзакцията',
  'label.first_name': 'Първо име',
  'label.gender': 'Пол',
  'label.goal': 'Цел',
  'label.journey_activity': 'Дейности за Приключенско пътуване',
  'label.journey_objective': 'Цел на Приключенското пътуване',
  'label.journey_observations': 'Наблюдения по време на Приключенско пътуване',
  'label.journey_type': 'Тип на приключенското пътуване',
  'label.last_name': 'Фамилия',
  'label.level': 'Ниво',
  'label.location': 'Местонахождение',
  'label.logout': 'Изход',
  'label.major': 'Основно направление',
  'label.middle_name': 'Бащино име',
  'label.mode_of_transport': 'Начин на придвижване',
  'label.my_award_leader': 'Моят Лидер в Наградата',
  'label.name': 'Първо име',
  'label.nationality': 'Националност',
  'label.no': 'Не',
  'label.no_results': 'Няма резултати',
  'label.note': 'Бележки',
  'label.note_for_assessor': 'Бележки за Ментора',
  'label.note_for_leader': 'Бележки за Лидера',
  'label.optional': 'по избор',
  'label.organisation_name': 'Име на организацията',
  'label.organisation_type': 'Вид на организацията',
  'label.others': 'Друго',
  'label.password': 'Парола',
  'label.password_again': 'Повтори паролата',
  'label.project_location': 'Местонахождение на проекта',
  'label.pay_online': 'Плати онлайн',
  'label.pay_award_leader_or_unit': 'Плати на Лидера или организацията',
  'label.payment_not_required': 'Не се изисква плащане',
  'label.payment_type': 'Вид на плащането:',
  'label.phone': 'Телефон',
  'label.phone_number': 'Телефонен номер',
  'label.phone_type': 'Вид телефон',
  'label.profile': 'Профил',
  'label.reset_password': 'Смяна на парола',
  'label.region': 'Регион',
  'label.relationship': 'Връзка',
  'label.role_in_organisation': 'Роля в организацията',
  'label.select_country': 'Избери държава',
  'label.select_your_au': 'Избери организация',
  'label.start_typing': 'Започни да пишеш',
  'label.start_date': 'Начална дата',
  'label.select': 'Избери',
  'label.select_async': 'Започни да пишеш...',
  'label.select_your_operating_authority': 'Избери оператор на Наградата',
  'label.specify_category': 'Моля, уточнете категорията си',
  'label.subcategory': 'Подкатегория',
  'label.title': 'Обръщение',
  'label.username': 'Потребителско име',
  'label.what_is_your_role': 'Каква е ролята Ви в организацията?',
  'label.where_have_you_completed': 'Къде си завършил ниво на Наградата?',
  'label.yes': 'Да',
  'label.your_changes_havent_been_saved': 'Промените не са запазени. Информацията ще бъде изгубена.',
  'label.zip': 'Пощенски код',
  'label.adventurous_journey': 'Приключенско пътуване',
  'label.after_your_journey_describe': 'Опиши наблюденията си от Приключенското пътуване с няколко изречения.',
  'label.because_your_age_is_under_18': 'Тъй като си под 18 годишна възраст, имаме нужда от съгласието на родител или настойник.',
  'label.before_you_head_to_journey': 'Преди да продължиш със същинското си Приключенско пътуване, трябва да попълниш информация за подготовката и инструктажите.',
  'label.before_entering_new_level': 'Преди да продължиш към следващото ниво на Наградата, трябва да потвърдиш, че личните ти данни са актуални.',
  'label.bring_required_amount_to_your_award_leader': 'Занеси таксата на Лидера си или на Координатора в организацията.',
  'label.do_you_have_any_other_level': 'Имаш ли друго завършено ниво в Наградата?',
  'label.do_you_know_who_is_your_award_leader': 'Знаеш ли кой е твоят Лидер в Наградата?',
  'label.going_on_an_expedition': 'Участието в Приключенско пътуване ти дава възможност да преживееш приключение, да работиш в екип и да поемаш инициатива.',
  'label.going_on_residential_gives_chance': 'Участието в Проект в полза на общността ти дава възможност да се научиш да работиш с хора от различен произход и да изградиш увереност, че можеш да се справиш в нова среда.',
  'label.i_confirm_that_i_meet': 'Потвърждавам, че отговарям на всички условия на Националния оператор на Наградата.',
  'label.i_agree_to_volunteer_code': 'Съгласявам се с Кодекса на поведение на доброволеца. За повече информация, кликни тук.',
  'label.i_have_read_the_terms_and_conditions': 'Запознах се и съм съгласен с Правилата и условията за ползване.',
  'label.i_will_bring_the_consent_to_my_award_leader_later': 'Ще предам декларацията за родителско съгласие на моя Лидер по-късно.',
  'label.if_you_are_from_orphanage': 'Ако идваш от ЦНСТ, не се налага да плащаш такса за участие в Наградата.',
  'label.here_you_can_add_activity': 'Тук можеш да добавиш допълнителни дейности за подготовка и инструктажи.',
  'label.how_do_you_want_to_apply': 'Как би искал да кандидатстваш:',
  'label.my_parent_consent_has_been_already_given': 'Декларацията за съгласие от моя родител/настойник вече е предадена на моя Лидер в Наградата.',
  'label.my_parent_will_confirm_consent_by_email': 'Моят родител/настойник ще изпрати декларацията по имейл.',
  'label.major_activity_means_that_you_have_to_spent': 'Основно направление означава, че трябва да отделиш два пъти повече време за тази дейност в сравнение с останалите.',
  'label.not_sure_about_your_auth': 'Не си сигурен към коя организация ще си участник? Свържи се с нас на:',
  'label.page_not_found': '404 - Страницата не е намерена.',
  'label.please_fill_in_the_following': 'Моля, попълнете следните данни за притежателя на разрешението за контакт / лиценза във вашата организация',
  'label.register_a_new_account_as': 'Регистрирай нов профил като:',
  'label.residential_project': 'Проект в полза на общността',
  'label.select_your_award_unit': 'Избери организация',
  'label.the_expedition_can_be_faraway': 'Приключенското пътуване може да бъде толкова отдалечено или близо до дома, колкото искате, и има стотици начини, по които можете да го направите.',
  'label.to_log_your_process_on_orb': 'За да впишеш прогреса си в онлайн системата на Наградата (ORB), трябва да имаш свой личен ORB профил. <br /> Моля, въведи данните си тук.',
  'label.waiting_for_assessment': 'Изчакване на оценка.',
  'label.waiting_for_sign_off': 'Изчакване на одобрение от Лидера.',
  'label.we_have_sent_you_an_email': 'Изпратихме ти имейл с линк за активиране на профила.',
  'label.what_level_of_the_award': 'За кое ниво на Наградата се регистрираш?',
  'label.you_are_now_registering_as_participant': 'В момента се регистрираш като участник в Наградата.',
  'label.you_are_now_registering_as_award_unit': 'В момента се регистрирате като Лицензиран оператор на Наградата.',
  'label.you_can_use_my_photos_for_promotional_purposes': 'Като участник в Наградата, давам съгласието си Фондацията на Наградата да използва снимките ми за рекламни цели.',
  'label.you_can_send_activity_for_approval': 'Можеш да изпратиш дейността си към Ментора си за одобрение.',
  'label.you_can_send_activity_for_leader': 'Можеш да изпратиш дейността си към Лидера си за одобрение.',
  'label.you_can_send_residential_project_to_leader': 'Можеш да изпратиш своя Проект в полза на общността към Лидера си за одобрение.',
  'label.you_have_finished_now_send_to_approval': 'Готов/а си. Сега можеш да го изпратиш към Ментора си за одобрение. Можеш да добавиш и лична бележка.',
  'label.preparation_and_training': 'Подготовка и инструктажи',
  'label.you_will_be_redirected_to_the_payment': 'Ще бъдете пренасочени към страницата за плащане, през която ще можете да платите с кредитна или дебитна карта.',
  'label.you_will_be_the_first_award_leader': 'Вие ще сте първият Лидер във Вашата организация. Вие ще имате право да добавяте нови Лидери, участници и да управлявате процеса на Наградата през онлайн системата (ORB).',
  'label.youll_receive_a_notification': 'Ще получиш известие когато твоят Лидер одобри регистрацията ти. Можеш да влезеш в профила си в ORB <a>тук</a> (преди Лидерът ти да одобри регистрацията ти, функционалността е ограничена).',
  'label.your_parent_email': 'Имейл на родителя/настойника',
  'label.your_parent_first_name': 'Първо име на родителя/настойника',
  'label.your_parent_last_name': 'Фамилия на родителя/настойника',
  'label.your_report_approve_now_send_to_leader': 'Твоят доклад е одобрен от Ментора ти. Сега можеш да го изпратиш към Лидера си за одобрение. Можеш да добавиш и лична бележка по-долу.',
  'label.there_are_loads_of_exciting_possibilities': 'Съществуват много вълнуващи възможности. Избери нещо, което ще ти е приятно и интересно.',
  'label.your_residential_project_has_been_setup': 'Твоят Проект в полза на общността е настроен и изпратен към твоя Лидер за одобрение.',
  'label.your_report_has_been_sent_assessor': 'Докладът ти е изпратен до Ментора за одобрение.',
  'label.your_report_has_been_sent_leader': 'Докладът ти е изпратен до Лидера за одобрение.',
  'label.your_residential_project_is_complete': 'Твоят Проект в полза на общността е приключен.',
  'label.to_work_on_the_online': 'За да работиш в онлайн системата на Наградата (ORB), трябва да имаш личен профил.',
  'label.we_will_send_you_an_email': 'Ще ти изпратим имейл, когато твоята регистрация е одобрена.',
  'label.if_you_have_any_problems_or_doubts': 'Ако срещаш проблеми или имаш върпоси, можеш да се свържеш със своята организация.',
  'label.are_you_sure_you_want_to_leave': 'Сигурен/а ли си, че искаш да излезеш? Информацията ще бъде загубена.',
  'label.no_logs_yet': 'Все още нямаш записи. <br /> Пробвай да въвдеш първия си запис, като натиснеш бутона "Добави запис"',
  'label.menu': 'Меню',
  'notifications.award_unit_has_been_created': 'Профилът на организацията е създаден',
  'notifications.authorization_code_is_not_valid': 'Кодът за упълномощаване не е валиден.',
  'notifications.email_has_been_confirmed': 'Имейл адресът е потвърден.',
  'notifications.leader_has_been_created': 'Профилът на Лидер е създаден',
  'notifications.participant_has_been_created': 'Профилът на участник е създаден',
  'notifications.email_with_instructions_has_been_sent': 'Изпратен е имейл с инструкции',
  'notifications.your_new_password_has_been_set': 'Новата парола е настроена.',
  'notifications.success': 'Готово',
  'notifications.unknown_role': 'Неизвестна роля',
  'notifications.waiting_for_approval': 'Изчакване на одобрение',
  'notifications.activity_cannot_be_created': 'Не можеш да създадеш дейност преди регистрацията ти да е одобрена.',
  'notifications.new_activity_has_been_added': 'Добавена е нова дейност',
  'notifications.new_log_has_been_added': 'Добавен е нов запис',
  'notifications.log_has_been_deleted': 'Записът е изтрит',
  'notifications.log_has_been_modified': 'Записът е редактиран',
  'notifications.adventurous_journey_cannot_be_created_until_approved': 'Не можеш да създадеш Приключенско пътуване преди регистрацията ти да е одобрена',
  'notifications.new_participant_event_has_been_added': 'Добавено е ново събитие за участници',
  'notifications.participant_event_has_been_completed': 'Събитието за участници е готово',
  'notifications.training_and_practice_modified': 'Инструктажът и практиката са променени',
  'notifications.completion_residential_project_completed': 'Проект в полза на общността е завършен.',
  'notifications.new_residential_project_has_been_added': 'Добавен е нов проект в полза на общността',
  'notifications.residential_project_cannot_be_created_until_approved': 'Не можеш да създадеш Проект в полза на общността преди регистрацията ти да е одобрена',
  'notifications.already_assessed_sent': 'Изпратено е запитване за одобрение от Лидер',
  'notifications.assessment_request_sent': 'Изпратено е запитване за оценка от Лидер',
  'notifications.leader_approval_sent': 'Изпратено е запитване за одобрение от Лидер',
  'tabs.logs': 'Записи',
  'tabs.new': 'Нов',
  'tabs.overview': 'Общ преглед',
  'tabs.report': 'Доклад',
  'button.add_activity': 'Добави дейност',
  'button.add_log': 'Добави запис',
  'button.continue_here': 'Продължи тук',
  'button.continue': 'Продължи',
  'button.continue_to_award': 'Продължи към Наградата',
  'button.delete': 'Изтрий',
  'button.edit': 'Редактирай',
  'button.edit_log': 'Редактирай записа',
  'button.finish': 'Завърши',
  'button.forgot_your_password': 'Забравена парола?',
  'button.i_already_have_assessment': 'Вече съм преминал етапа на оценка',
  'button.leave_anyway': 'Излез',
  'button.login': 'Вход',
  'button.no': 'Не',
  'button.register': 'Регистрирай се',
  'button.send': 'Изпрати',
  'button.send_for_approval': 'Изпрати за одобрение',
  'button.setup': 'Въвеждане',
  'button.setup_residential': 'Въведи Проект в полза на общността',
  'button.stay': 'Остани',
  'button.submit': 'Изпрати',
  'button.update': 'Актуализирай',
  'button.yes': 'Да',
  'errors.at_least_num_characters': 'Дълга поне {length} символа',
  'errors.do_not_match': 'Не съвпада',
  'errors.include_at_least_one_number': 'Включва поне една цифра',
  'errors.include_both_lower_and_upper_case': 'Включва главни и малки букви',
  'errors.invalid_phone_format': 'Невалиден номер',
  'errors.invalid_email_address': 'Невалиден имейл',
  'errors.required_field': 'Задължително поле',
  'errors.must_be_at_least': 'Трябва да е поне {min} символа',
  'errors.must_be_no_more_than': 'Не трябва да е повече от {max} символа',
  'errors.must_be_an_integer': 'Трябва да е цяло число',
  'errors.must_contain_at_least': 'Трябва да съдържа поне една цифра',
  'errors.must_include_at_least': 'Трябва да съдържа поне една главна буква',
  'errors.must_be_one_of': 'Трябва да е едно от: {enums}',
  'errors.you_must_be_younger_than': 'Трябва да си по-малък от {years} години и {months} месеца, за да се регистрираш за Наградата. Можеш да разговаряш с Координатора в твоята организация.',
  'errors.you_must_be_older_than': 'Трябва да си по-голям от {years} години и {months} месеца, за да се регистрираш за Наградата. Можеш да разговаряш с Координатора в твоята организация.',
  'errors.email_address_is_in_use_please_sign': 'Имейл адресът вече е използван. Ако искаш да се регистрираш за друго ниво, трябва да влезеш в профила си.',
  'errors.email_address_is_in_use': 'Имейл адресът вече е използван.',
  'errors.sorry_we_already_have_this_email':
    "Извиняваме се, но вече имаме профил, който използва този имейл адрес. Ако искаш да започнеш ново ниво <a href='/'>влез в профила си</a> и избери опцията \"Започни ново ниво\"/",
  'wizard.authorising_contact': 'Упълномощен контакт',
  'wizard.award_leader_contact': 'Контакт на Лидера',
  'wizard.award_unit_details': 'Информация за организацията',
  'wizard.contact_details': 'Контактна информация',
  'wizard.contacts': 'Контакти',
  'wizard.level': 'Ниво в Наградата',
  'wizard.level_selection': 'Избор на Награда',
  'wizard.leader_details': 'Информация за Лидера',
  'wizard.nominated_award_leader': 'Номиниран Лидер',
  'wizard.orb_account': 'Профил в ORB',
  'wizard.parent_consent': 'Родителско съгласие',
  'wizard.participant_details': 'Информация за участника',
  'wizard.profile': 'Профил',
  'wizard.payment': 'Плащане',
  'wizard.select_award_unit': 'Избери регистрирана организация',
  'wizard.unit_details': 'Информация за регистрираната организация',
  'wizard.welcome': 'Добре дошъл/а',
  'wizard.your_details': 'Твоите детайли',
  'awardUnit.do_you_want_to_create': 'Искате ли да създадете нов профил на организация?',
  'parent.you_can_download_the_consent_here': 'Можеш да свалиш Формуляра за родителско съгласие тук, ако все още го няма. Формулярът трябва да е подписан от родител/настойник и да го дадеш на Лидера си.',
  'footer.copyright': '&copy; Авторски права Международна награда на херцога на Единбург - {year}',
  'registration_participant.required_award_payment': 'Изисква се плащане на таксата за участие',
  'registration_participant.pay_online_here': 'Плати онлайн и виж номера на транзакцията тук.',
  'dashboard.activity_log_time': '{hours}ч. {minutes}мин.',
  'moduleTitle.award_completed': 'Наградата е завършена!',
  'notifications.award_approval_request_sent_to_leader': 'Изпратено е запитване за одобрение от Лидер',
  'notifications.new_participant_event_has_been_completed': 'Беше добавено ново събитие за участници',
  'notifications.preparation_and_training_approval_sent': 'Изпратено е одобрение за подготовка и инструктажи.',
  'notifications.reparation_and_training_completed': 'Подготовката и инструкатижте са приключени.',
  'notifications.your_profile_photo_has_been_edited': 'Профилната ти снимка е редактирана',
  'notifications.your_profile_has_been_edited': 'Профилът ти е редактиран.',
  'notifications.new_level_has_started': 'Започнато е ново ниво в Наградата',
  'notifications.activity_has_been_edited': 'Дейността е редактирана',
  'notifications.you_have_been_logged_out': 'Изход...',
  'notifications.logging_out': 'Излязохте от профила си',
  'label.you_can_send_award_to_leader': 'Можеш да изпратш Наградата си за одобрение от Лидер.',
  'label.you_have_completed_all_sections_of_your_award': 'Приключил си с всички направления в Наградата. Можеш да изпратиш Наградата си за одобрение от Лидер. По-долу можеш да добавиш бележка.',
  'label.you_have_now_completed_your_award': 'Приключи своето ниво {level} в Наградата. Искаш ли да продължиш на следващото?',
  'label.congratulation_your_award_has_been_approved': 'Поздравления. Твоето ниво {level} е одобрено! <br /> Ако искаш, можеш веднага да започнеш ново ниво.',
  'moduleTitle.settings': 'Настройки',
  'moduleTitle.edit_activity': 'Редактирай дейността',
  'moduleTitle.select_your_major_activity': 'Избери основното си Направление',
  'label.settings': 'Настройки',
  'label.major_activity_means_that_you_will': 'Основно направление означава, че трябва да отделиш повече време за тази дейност в сравнение с останалите. За ниво Злато и Сребро, допълнителното време е 6 месеца. За ниво Бронз е три месеца.',
  'label.notifications': 'Известия',
  'label.my_award': 'Моята Награда',
  'label.physical_recreation': 'Физическа активност',
  'label.skill': 'Умение',
  'label.service': 'Доброволчество',
  'label.my_parent_will_complete_and_sign_form': 'Моят родител/настойник ще попълни и подпише формуляра за родителско съгласие.',
  'label.please_print_it_tak_it_to_your_parent': 'Моля, принтирай формуляра и го дай на родител/настойник за подпис, а после го занеси на Лидера си.',
  'label.change_password': 'Промени парола',
  'label.change_major_activity': 'Промени основно Направление',
  'title.change_password': 'Промени парола',
  'label.old_again': 'Стара парола',
  'label.new_password': 'Нова парола',
  'label.new_password_again': 'Нова парола още веднъж',
  'errors.passwords_dont_match': 'Паролите не съвпадат',
  'errors.more_than': 'Повече от {limit}',
  'button.parent_guardian_consent_pdf': 'Формуляр за родителско/настойническо съгласие.pdf',
  'button.send_award_for_approval': 'Изпрати Наградата за одобрение',
  'button.send_report': 'Изпрати доклад',
  'button.terms_and_conditions': 'Международни правила и условия',
  'button.privacy_policy': 'Политика за поверителност',
  'button.save': 'Запази',
  'button.start_new_level': 'Започни ново ниво',
  'button.change_password': 'Промени паролата',
  'button.edit_activity': 'Редактирай дейността',
  'moduleTitle.file_upload': 'Качване на файл',
  'label.add_file': 'Добави файл',
  'label.description': 'Описание',
  'label.waiting_for_office_sign_off': 'Изчакване на одобрение от офиса на Наградата.',
  'notifications.file_has_been_uploaded': 'Файлът е качен',
  'tabs.files': 'Файлове',
  'button.upload': 'Качване',
  'button.upload_file': 'Качване на файл',
  'button.add_file': 'Добави файл',
  'button.this_activity_has_no_assessor': 'Тази дейност няма Ментор. Трябва да добавиш информация за Ментора, преди да я изпратиш за одобрение.',
  'label.i_want_to_register_my_award': 'Искам да регистрирам организацията като Независим Център на Наградата',
  'label.select_sub_operating_authority': 'Избери местен оператор',
  'label.your_must_first_setup_some_activity': 'Първо трябва да въведеш информация за дейността.',
  'label.you_cant_change_your_major_activity': 'Не можеш да смениш основната си дейност. Основната ти дейност е завършена.',
  'label.s_specific': '<b>S-Specific - Конкретна: Целта ви не трябва да бъде твърде обща.</b> Вместо: "Искам да бъда по-добър на цигулка", би могъл да напишеш: "Бих искал да овладея F скала при свирене на цигулка".',
  'label.m_measurable': '<b>M-Measurable - Измерима: Трябва да можеш да разбереш кога си постигнал своята цел. </b>Вместо да зададеш цел като "Искам да помогна на общността", би могъл да напишеш: "Искам да помогна на хората, които посещават кухни за бедни, чрез доброволчески дейности веднъж седмично". По този начин целта може да бъде тествана.',
  'label.a_achievable': '<b>A-Achievable - Постижима: Твоята цел трябва да бъде нещо, което можеш да постигнеш в рамките на конкретното ниво в Наградата. </b>Вместо "Искам да сложа край бедността", по-добре би било да си поставиш по-практична цел като "бих искал да набера средства за подпомагане на село в държава от третия свят".',
  'label.r_realistic': '<b>R-Realistic - Реалистична: Това е почти същото като "постижима". </b>Реалистично ли е да постигнеш целите си за този период от време?',
  'label.t_timely': '<b>T-Timely или Time-Based - С краен срок: Твоята цел трябва да включва информация кога искаш да постигнеш целта си.</b> Твоята цел може да бъде, "Бих искал да овладея F-скала на цигулка в рамките на три месеца".',
  'label.you_can_upload_here_any_files': 'Можеш да качваш всякакви файлове, които искаш да споделиш с Лидера си.',
  'moduleTitle.login_change': 'Промяна на входа',
  'notifications.adventurous_journey_modified': 'Приключенското пътуване е променено',
  'tabs.sections': 'Направления',
  'label.change_email': 'Промени имейла',
  'title.change_email': 'Промени имейла',
  'label.new_email': 'Нов имейл',
  'label.new_email_again': 'Новият имейл още веднъж',
  'errors.emails_dont_match': 'Имейлите не съвпадат',
  'button.change_email': 'Промени имейла',
  'notifications.email_with_instructions_has_been_sent_to_your_inbox': 'Инструкциите са изпратени по имейл',
  'global.dofe_name': 'Наградата на херцога на Единбург',
  'global.or': 'или',
  'route.landing_page': 'Начална страница',
  'route.dashboard': 'Табло за упавление',
  'moduleTitle.notifications': 'Известия',
  'moduleTitle.no_notifications': 'Няма известия',
  'moduleTitle.new_notifications': 'Нови известия',
  'moduleTitle.older_notifications': 'Стари извести',
  'moduleTitle.user_guide': 'Наръчник за потребители',
  'label.user_guide': 'Наръчник за потребители',
  'notifications.your_password_has_been_changed': 'Паролата е променена',
  'label.country': 'Държава',
  'label.on_your_smartphone': 'На телефона',
  'label.on_the_web': 'В мрежата',
  'label.orb_online': 'онлайн ORB',
  'label.language': 'Език',
  'moduleTitle.participant_login': 'Вход за участници',
  'label.for_ios': 'за iOS',
  'label.for_android': 'за Андроид',
  'button.login_as_award_staff': 'Вход за служители на Наградата',
  'errors.leader_doesnt_exist': 'Лидерът не съществува',
  'global.loading': 'Зареждане',
  'moduleTitle.award_staff_login': 'Вход за служители на Фондацията',
  'formTitle.residential_project_details': 'Информация за Проект в полза на общността',
  'label.you_can_also_download_participant': 'Можеш да изтеглиш нашето ново <strong>Приложение за участници</strong> и да имаш достъп до ORB навсякъде и по всяко време.',
  'label.you_can_also_download_leader': 'Можеш да изтеглиш нашето ново <strong>Приложение за Лидери</strong> и да имаш достъп до ORB навсякъде и по всяко време.',
  'notifications.this_role_is_not': 'Тази роля в момента не се поддържа',
  'notifications.residential_project_has_been_updated': 'Проектът в полза на общността е актуализиран',
  'tabs.participant': 'Участник',
  'tabs.award_staff': 'Служители на Наградата',
  'moduleTitle.edit_residential_project': 'Редактирай Проект в полза на общността',
  'button.residential_project': 'Редактирай Проект в полза на общността',
  'notifications.your_login_email_has_been_changed': 'Твоят имейл за вход е променен',
  'meta.dofe_name': 'Международна награда на херцога на Единбург',
  'notifications.unknown_role_leader': 'Неизвестна роля - използвайте вход за служители на Фондацията',
  'notifications.unknown_role_participant': 'Неизвестна роля - използвайте вход за участници',
  'label.user_guide_web_participant': 'Ръководство за потребители - Участник',
  'label.user_guide_app_participant': 'Ръководство за потребители за приложение - Участник',
  'label.note_for_supervisor': 'Бележка за Супервайзора',
  'label.before_submitting_your_aj': 'Преди да изпратиш Приключенското си пътуване към Лидера, трябва да получиш одобрение от {role}. Ако искаш, можеш да добавиш лична бележка.',
  'button.back_to_home': 'Обратно към началната страница',
  'moduleTitle.assessor_approval': 'Одобрение от {role}',
  'label.this_aj_has_no_assessor': 'Това Приключенско пътуване няма {role}. Трябва да актуализираш информацията, преди да я изпратиш за одобрение.',
  'route.not_found': 'Не е намерено',
  'notifications.are_you_sure': 'Сигурен/а ли си?',
  'button.cancel': 'Отказ',
  'label.add_document': 'Добави документ',
  'errors.there_are_currently_no_details_for_your': 'В момента няма информация за твоя {role}. Моля, попълни липсващите детайли преди да изпратиш дейността си за оценка',
  'moduleTitle.missing_data': 'Липсващи данни',
  'label.to_send_assessment_request': 'Ако искаш да изпратиш запитването за оценка електронно, моля попълни имейла на {role}',
  'label.pending_changes': 'Предстоящи проблеми',
  'label.some_fields_require': 'Обърнете внимание на някои от полетата.',
  'roles.assessor': 'Оценител',
  'roles.supervisor': 'Супервайзор',
  'pageTitle.register_participant': 'Регистрирай участник',
  'moduleTitle.revise_message': 'Редактирай съобщението',
  'moduleTitle.payment_for_level': 'Плащане за {awardLevel}',
  'moduleTitle.payment': 'Плащане на такса за участие',
  'moduleTitle.we_have_sent_you_payment_link': 'Изпратихме имейл с линк към портала за плащане',
  'label.required_award_payment': 'Изисква се плащане на такса за участие',
  'label.payment_fees': 'такси за плащане',
  'label.payment_method': 'Начин на плащане',
  'label.you_will_type_trans_id': 'Ще трябва да въведеш ID на транзакцията',
  'label.any_level_previously': 'Предишно постигнато ниво',
  'label.registering_for_level': 'Регистрация за ниво',
  'notification.payment_link_expired': 'Линкът за плащане е изтекъл',
  'button.pay': 'Плати',
  'label.registration_updated': 'Регистрацията ти е актуализирана, можеш да затвориш страницата.',
  'label.award_leader_receive_payment': 'Твоят Лидер в Наградата ще получи информация за плащането.',
  'errors.end_date_after': 'Крайната дата трябва да е след началната дата',
  'button.back': 'Назад',
  'button.edit_info': 'Редактирай информация',
  'moduleTitle.level_detail': 'Детайли за нивото',
  'label.payment_methods': 'Начини на плащане',
  'label.address': 'Адрес',
  'note.review_filled_participant': 'Моля прегледайте информацията, попълнена от участника. Ако има невярна информация, можете да я редактирате.',
  'moduleTitle.payment_successful': 'Плащането на таксата за участие е успешно',
  'button.proceed_to_login': 'Вход',
  'label.add_additional_activity': 'Добави допълнителна дейност',
  'moduleTitle.welcome_to_orb': 'Добре дошъл в Онлайн системата на Наградата',
  'empty_dashboard.not_approved': 'Този инструмент ще ти помогне да записваш прогреса си в Наградата. Но профилът ти все още не е одобрен от твоя Лидер. Преди да впишеш първата си дейност, ще трябва да изчакаш одобрение.',
  'empty_dashboard.approved_1': 'Този инструмент ще ти помогне да записваш прогреса си в Наградата',
  'empty_dashboard.approved_2': 'Първо трябва да ',
  'label.discuss_activity_leader': 'Ако избираш повече от една дейност, моля обсъди го с Лидера си. ',
  'label.cannot_add_activity': 'Можеш да добавиш максимум три дейности в тази категория. Моля, обсъди го с Лидера си.',
  'button.ok': 'ОК',
  'label.payment_was_canceled': 'Плащането е отказано от потребителя',
  'label.problem_with_payment': 'Имаше проблем при плащането. Моля, свържи се с Националния Оператор на Наградата.',
  'pageTitle.register_leader': 'Регистрация на Лидер',
  'pageTitle.registration_complete': 'Регистрацията е завършена',
  'label.payment_link_expired_or_paid': 'Вече си платил таксата за регистрация или линкът е изтекъл.',
  'label.contact_nao_assistance': 'Свържи се с Националния оператор, ако имаш нужда от помощ.',
  'label.send_required_amount_to_your_award_leader': 'Изпрати таксата на своя Лидер или Координатор в твоята организация.',
  'label.fee_can_be_paid': 'Таксата може да бъде платен онлайн чрез Visa, Master Card или кредитини и дебитни карти.',
  'notifications.login_failed_right_tab': 'Неуспешно влизане. Увери се, че си избрал подходящата сексия (Участник / Лидер)',
  'label.i_have_read_privacy_policy': 'Прочетох правилата за поверителност и съм съгласен с тях.',
  'errors.invalid_date_format': 'Невалиден формат на датата.',
  'label.no_privacy_policy': 'Не са намерени правила за поверителност. Можете да продължите като натиснете бутона.',
  'label.status': 'Статут',
  'moduleTitle.attached_with_observation': 'Добавено е наблюдение',
  'moduleTitle.revise_message_rp': 'Твоят Проект в полза на общността е редактиран от Лидера ти.',
  'file.activity_section_summary': '{section} обощение',
  'label.download_section_summary': 'Изтегли обощение за направлението',
  'label.award_summary': 'Обобщение на Наградата',
  'btn.download_summary_for_assessor': 'Изтегли обощение за ментора',
  'label.first_activity_started': 'Първата дейност е започната',
  'label.hours_completed_required': 'Часове изпълнени/ изисквани часове',
  'label.weeks_completed_required': 'Седмици изпълнени / изисквани седмици',
  back_to_home: 'Обратно в началото',
  'label.activity_rejected_click': 'Твоята дейност е отказана от твоя Лидер. Кликни тук за ',
  'button.more_information': 'повече информация',
  'label.attached_file': 'Прикачен файл',
  'moduleTitle.journey_details': 'Детайли за пътуването',
  'tabs.activity': 'Дейност',
  'label.confirm_email': 'Потвърди имейла',
  'label.aj_rejected_click': 'Твоето Приключенско пътуване е отказано от твоя Лидер. Кликни тук за ',
  'label.verifying_payment': 'Потвърждаване на плащането',
  'button.finish_and_pay': 'Завършване и плащане',
  'label.payment_not_successful_text': 'Тъй като плащането на таксата не е завършено успешно, трябва да направиш плащане сега',
  'label.payment_not_completed': 'Плащането не е завършено',
  'button.pay_now': 'Плати сега',
  'label.registration_pending_parental_consent': 'Регистрацията ти изисква съгласие на Родител/ настойник',
  'button.edit_observation': 'Редактирай наблюденията',
  'moduleTitle.qualifying': 'Същинско',
  'moduleTitle.practice': 'Предварително',
  'label.first_log_entry': 'Първи запис',
  'label.first_log_entry_date': 'Дата на първия запис',
  'label.last_log_entry': 'Последен запис',
  'label.last_log_entry_date': 'Дата на последния запис',
  'label.you_can_send_journey_report_for_approval': 'Можеш да изпратиш доклада от своето {journey} пътуване за одобрение.',
  'button.edit_and_resend_report': 'Редактирай и изпрати отново',
  'label.your_journey_is_complete': 'Твоето {journeyType} пътуване е завършено',
  'button.add_additional_journey': 'Добави допълнително пътуване',
  'moduleTitle.edit_journey': 'Редактирай пътуването',
  'notifications.assessment_sent': 'Изпратена е оценка',
  'notifications.file_is_too_big': 'Файлът не може да бъде качен. Най-вероятно е твърде голям.',
  'notifications.authorization_code_has_expired': '',
  'route.confirm_email': 'Потвърди имейла',
  'label.assessor_needs_account': '',
  'label.company_name': 'Име на фирмата',
  'label.secondary_email_again': 'Потвърди втория имейл',
  'label.how_many_years': 'Колко години/месеца?',
  'label.no_company_leave_empty': 'Ако не работите за фирма, оставете полето празно',
  'label.secondary_phone_number': 'Втори телефонен номер',
  'label.secondary_phone_type': 'Вид на втория телефонен номер',
  'label.wwc_application_number': '',
  'label.wwc_expiration_date': '',
  'label.you_are_now_registering_as_assessor': '',
  'label.you_have_finished_aj_now_send_to_approval': '',
  'label.your_experience': 'Вашият опит',
  'label.your_qualification': 'Вашата квалификация',
  'notifications.waiting_for_assessor_approval': '',
  'button.resend_assessment_request': '',
  'errors.emails_must_be_different': '',
  'moduleTitle.company_details': 'Детайли за фирмата',
  'notifications.already_resent_assessment_request': '',
  'route.assessor_dashboard': '',
  'pageTitle.register_assessor': '',
  'wizard.assessor_details': '',
  'wizard.assessor_experience': '',
  'wizard.personal_details': 'Лична информация',
  'button.sign_off': '',
  'button.sign_off_dashed': '',
  'moduleTitle.sign_off': '',
  'label.certify_participant_met_reqs': '',
  'label.assessor_report': 'Доклад на ментора',
  'label.content_update': '',
  'label.comment_on_participant_improvement': '',
  'note.edit_participant_review': '',
  'errors.min_age': '',
  'notifications.assessor_link_expired': '',
  'label.secondary_email': 'Втори имейл',
  'moduleTitle.review_participant_info': 'Преглед на информацията за участника',
  'label.loading_payment_gateway': '',
  'label.consent_given_login_as_child': '',
  'notifications.only_one_qualification_journey_per_award': '',
  'label.registration_fees_participant': '',
  'moduleTitle.leader_details': 'Информация за лидера',
  'label.leader_name': 'Име на лидера',
  'label.leader_phone': 'Телефон на лидера',
  'label.leader_email': 'Имейл на лидера',
  'moduleTitle.au_details': 'Информация за организацията',
  'label.au_name': 'Име на организацията',
  'label.assessor_guidelines': 'Насоки',
  'label.assessor_cond_req': 'Ключови изисквания и условия',
  'label.assessor_ref_handbook': '',
  'label.assessor_ref_online_modules': '',
  'label.participant_has_no_aj_report': '',
  'moduleTitle.participant_details': 'Детайли за участника',
  'label.participants_has_no_logs': 'Участникът все още няма записи.',
  'label.location_type': 'Вид на локацията',
  'label.activity_ready_for_signoff': 'Дейността е готова за одобрение.',
  'label.activities': 'Дейности',
  'label.choose_how_you_want_to_login': '',
  'roles.leader': 'Лидер',
  'roles.award_verifier': '',
  'roles.coordinator': 'Координатор',
  'roles.aj_assessor': 'Оценител на ПП',
  'roles.aj_supervisor': 'Супервайзор на ПП',
  'roles.instructor': 'Инструктор',
  'roles.nao_staff': '',
  'roles.super_user': '',
  'roles.user': 'Потребител',
  'roles.viewer': '',
  'roles.authorizing_contact': '',
  'roles.if_staff_superuser': '',
  'roles.if_staff_statistical_user': 'МФ статистически потребител',
  'roles.if_staff_viewer': 'МФ служител',
  'roles.aj_instructor': 'Инструктор на ПП',
  'label.if_you_have_questions_au': 'Ако имате някакви въпроси относно регистрацията си, моля свържете се с организацията, към която сте Лидер.',
  'label.we_will_send_you_an_email_leader': 'Ще ви изпратим имейл когато вашата регистрация в ОРБ е потвърдена.',
  'moduleTitle.rejecting_assessor_invitation': 'Отхвръляне на поканата да станете ментор.',
  'notifications.assessor_invitation_rejected': 'Поканата за ментор е отхврълена.',
  'moduleTitle.participants_list_is_empty': 'Списъкът с участници е празен',
  'label.note_from_participant': 'Бележка от участника',
  'label.you_can_send_aj_to_leader': 'Вече можеш да изпратиш приключенското си пътуване за одобрение от Лидер.',
  'button.save_report': 'Запази доклада',
  'label.this_activity_has_no_assessor': 'Тази дейност няма ментор. Трябва да въведеш данните на ментора преди да я изпратиш за одобрение.',
  'label.activity_rejected_click_by_assessor': 'Тази дейност е отказана от ментора. Клик за ',
  'button.reject': 'Отхвърли',
  'button.reject_invitation': 'Отхвърли поканата',
  'label.reason': 'Причина',
  'label.accept_invitation_and_continue': 'Приеми поканата и продължи',
  'pageTitle.registration_reject': 'Отхвърлена регистрация',
  'errors.you_must_be_older_than_register_for_leader': 'Трябва да си на поне {years} години и {months} месеца за да се регистрираш като Лидер в Наградата.',
  'label.your_report_approve_now_send_to_leader_without_note': 'Твоят доклад е одобрен! Можеш да изпратиш наградата си за одобрение от Лидер.',
  'button.stop_assessing_this_activity': 'СПРЕТЕ ОЦЕНКАТА НА ТАЗИ ДЕЙНОСТ',
  'button.confirm': 'потвърдете',
  'moduleTitle.are_you_sure': 'Сигурен ли сте?',
  'label.content_restore': 'Възстанови съдържанието',
  'button.stop_editing': 'Спрете редакцията',
  'notifications.activity_has_been_rejected': 'Дейността е отказана',
  'notifications.aj_has_been_rejected': 'Приключенското пътуване е отказано',
  'notifications.rp_has_been_rejected': 'Проектът в полза на общността е отказан',
  'moduleTitle.additional_files': 'Допълнителни файлове',
  'moduleTitle.no_additional_files': 'Допълнителни файлове',
  'moduleTitle.stop_assessing_section': 'Спрете да оценявате това направление',
  'label.show_security_and_refund_policy': 'Покажете политиката за сигурност',
  'moduleTitle.security_and_refund_policy': 'Политика за сигурност',
  'label.fees_payment': 'Плащане на такси',
  'label.redund_policy': 'Политика за връщане',
  'label.security_policy': 'Политика за сигурност',
  'label.leave_blank': 'Оставете празно',
  'label.frequently_asked_questions': 'Често задавани въпроси (ЧЗП)',
  'label.language_selection_is_disabled_for_iac': 'Изборът на език е спрян за Независими оператори на Наградата',
  'errors.min_nights_required': 'Необходими са минимум {nights} нощ/и.',
  'label.completion_date': 'Дата на приключване',
  'label.you_are_offline': 'Вие не сте свързан с интернет. Промените не са запазни.',
  'errors.start_date_after_award_start': 'Началната дата не може да бъде преди началото на Наградата.',
  'label.participants': 'Участници',
  'label.marketing_from_iaf': 'Изберете да получавате рекламни материали от Международната фондация.',
  'label.marketing_from_oa': 'Изберете да получавате рекламни материали от регионалния оператор.',
  'label.marketing_from_nao': 'Изберете да получавате рекламни материали от Националния оператор.',
  'label.select_iac': 'Изберете независим оператор на Наградата',
  'label.you_will_be_redirected_to_the_paypal_payment': '',
  'notifications.report_has_been_sent': '',
  'label.processing_paypal_payment': '',
  'label.loading_paypal_gateway': '',
  'label.payment_failed': '',
  'label.payment_has_been_cancelled': '',
  'roles.naa_oa_staff': '',
  'label.download_report_and_upload_signed_version': '',
  'button.download_summary_for_assessor': '',
  'label.pay_online_mastercard': '',
  'label.pay_online_paypal': '',
  'notifications.authorization_code_is_missing': '',
  'errors.unknown_payment_error': '',
  'errors.already_in_use_by_auth_contact': '',
  'roles.if_staff_stat_user': '',
  'moduleTitle.you_have_been_logged_out_due_to_inactivity': '',
  'announcement.survey_description.do_think_people_are_lazy': '',
  'announcement.survey_title.join_our_global_survey': '',
  'announcement.survey_button.if_below_25': '',
  'announcement.survey_button.if_over_25': '',
  'moduleTitle.privacy_and_cookie_policy': '',
  'label.we_have_made_some_important_changes': '',
  'button.i_agree': '',
  'button.see_more_details': '',
  'label.the_cookie_settings_on_this': ''
}
